<script setup lang="ts">
import CircleCheckIcon from '@/assets/icons/shared/circle/check.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';
</script>

<template>
  <UiButton>
    <CircleCheckIcon v-prefix />
    <span>{{ $t('ui.common.button.continue') }}</span>
  </UiButton>
</template>
